import { IconWrapper } from '../runtime';
export default IconWrapper('shortcut_subscript_normal', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none",
      "stroke-width": props.strokeWidth
    }
  }, [h("g", {
    "attrs": {
      "id": "group-0",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333'
    }
  }, [h("path", {
    "attrs": {
      "d": "M9.39985 7.76524L11.0422 9.45173C11.3406 9.75805 11.8608 9.5729 11.8985 9.14698L12.5061 2.28414C12.5336 1.97309 12.2725 1.71318 11.9616 1.74221L5.27815 2.3661C4.8597 2.40516 4.67321 2.9117 4.96641 3.21278L6.58239 4.87214C4.66556 6.84041 3.47998 9.55957 3.47998 12.5631C3.47998 13.0551 3.51179 13.5394 3.57342 14.0141C3.61397 14.3264 4.04701 14.34 4.15148 14.0429C5.09807 11.3511 6.98257 9.11992 9.39985 7.76524Z",
      "stroke": "none"
    }
  })]), h("g", {
    "attrs": {
      "id": "group-1",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[1] || typeof props.colors === 'string' && props.colors || 'white',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[1] || typeof props.colors === 'string' && props.colors || 'white'
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.48787 12.9867C3.48263 12.8461 3.47998 12.7048 3.47998 12.5629C3.47998 9.55943 4.66556 6.84028 6.58239 4.872L4.96641 3.21264C4.67321 2.91156 4.8597 2.40503 5.27815 2.36597L11.9616 1.74207C12.2725 1.71305 12.5336 1.97295 12.5061 2.284L11.8985 9.14685C11.8608 9.57276 11.3406 9.75792 11.0422 9.45159L9.39985 7.7651C7.2488 8.97059 5.51963 10.8702 4.49782 13.1707C4.45251 13.2727 4.40859 13.3755 4.36609 13.4791C4.30452 13.6291 4.24592 13.7807 4.19037 13.9339C4.17723 13.9701 4.16427 14.0064 4.15148 14.0428C4.04701 14.3398 3.61397 14.3263 3.57342 14.014C3.56556 13.9534 3.55817 13.8926 3.55128 13.8317C3.53327 13.6725 3.5186 13.5122 3.50736 13.351C3.49893 13.2301 3.49242 13.1086 3.48787 12.9867ZM9.23939 9.03366C7.34759 10.2861 5.87433 12.158 5.09484 14.3745C4.88148 14.9812 4.31483 15.2777 3.79664 15.256C3.25477 15.2333 2.67337 14.8484 2.58175 14.1427C2.51459 13.6255 2.47998 13.0981 2.47998 12.5629C2.47998 9.64629 3.50737 6.97069 5.21463 4.90085L4.25 3.91032C3.37038 3.00708 3.92988 1.48748 5.1852 1.37029L11.8686 0.746399C12.8013 0.659328 13.5848 1.43905 13.5022 2.37219L12.8946 9.23503C12.7815 10.5128 11.2208 11.0682 10.3258 10.1493L9.23939 9.03366Z",
      "stroke": "none"
    }
  })])]);
});